module.exports = __webpack_public_path__ + "media/images/Icon-search_plus-278492a2a0c48f9c8d23b38341441a10.svg";